// extracted by mini-css-extract-plugin
module.exports = {"component":"search-widget-modal_component__tYChJ","curtain":"search-widget-modal_curtain__6hxQV"};